import type { CurrentUser } from "@/lib/auth";

/** Dezember (lokal) oder Dev-Simulation. */
export function isChristmasSeason(user?: CurrentUser | null, today = new Date()): boolean {
  if (user?.dev_simulate_christmas) return true;
  return today.getMonth() === 11;
}

/**
 * Komplette Woche vor Halloween einschließlich Halloween (24.–31. Oktober, lokal)
 * oder Dev-Simulation.
 */
export function isHalloweenSeason(user?: CurrentUser | null, today = new Date()): boolean {
  if (user?.dev_simulate_halloween) return true;
  if (today.getMonth() !== 9) return false;
  const day = today.getDate();
  return day >= 24 && day <= 31;
}
